export const parseBRNumber = (value: string): number | undefined => {
  if (!value) return
  return Number(
    value
      .replace(/\./g, '')
      .replace(',', '.')
      .replace(/[^\d.]/g, '')
  )
}

export const formatBRNumber = (value: number | string, decimals = 2, suffix?: string): string => {
  if (value === null || value === undefined || value === '') return ''

  const numberValue = typeof value === 'number' ? value : parseBRNumber(value)

  if (numberValue === undefined) return ''

  const formatted = numberValue.toLocaleString('pt-BR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })

  return suffix ? `${formatted} ${suffix}` : formatted
}
